import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"


export default /*#__PURE__*/_defineComponent({
  name: 'Footer',
  setup(__props) {

const version = process.env.VUE_APP_VERSION;

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("p", null, " Protractor Companion App | Version " + _toDisplayString(_unref(version)), 1)
  ]))
}
}

})